/**
 * Accordion tools.
 */
function accordion_tools() {
    /**
     * Closing duration of the accordion. This should be same as CSS transition duration.
     */
    const closingDuration = 500;

    /**
     * Determine if sticky header tools are available and store a value to this constant variable.
     */
    const stickyHeaderEnabled =
        typeof window.sticky_header_tools !== 'undefined';

    /**
     * Whether or not only a single accordion item should be allowed open at a given time.
     */
    const singleItemMode = stickyHeaderEnabled ? true : false; // Currently single item mode depends on sticky header tools

    /**
     * Prevent the supplied accordion button from animating, if the button is not in the visible viewport.
     *
     * @param {*} button An accordion button
     */
    function preventAnimationIfNotVisible(button) {
        if (!stickyHeaderEnabled) {
            return;
        }
        if (window.sticky_header_tools.isElementVisible(button)) {
            return;
        }

        button.classList.add('-do-not-animate');
        setTimeout(
            (button) => {
                button.classList.remove('-do-not-animate');
            },
            closingDuration,
            button
        );
    }

    /**
     * Closes all accordion items.
     */
    function closeAllAccordions() {
        const accordion_buttons = document.querySelectorAll(
            '.js-accordion-button'
        );

        accordion_buttons.forEach((button) => {
            preventAnimationIfNotVisible(button);
            button.setAttribute('aria-expanded', 'false');
        });
    }

    /**
     * Immediately scroll to the supplied accordion button.
     *
     * @param {*} button An accordion button
     */
    function scrollToAccordion(button) {
        if (!stickyHeaderEnabled) {
            return;
        }
        if (window.sticky_header_tools.isElementVisible(button)) {
            return;
        }
        window.sticky_header_tools.scrollTo(button, false);
    }

    /**
     * Toggle a single accordion item.
     *
     * @param {*} button An accordion button
     */
    function toggleAccordion(button) {
        const isClosed = button.getAttribute('aria-expanded') !== 'true';

        if (isClosed && singleItemMode) {
            closeAllAccordions();
        }

        button.setAttribute('aria-expanded', isClosed);

        if (singleItemMode) {
            scrollToAccordion(button);
        }
    }

    /**
     * Makes all accordions inside the supplied element open and close when clicked.
     *
     * This function may need to be reaplied if the DOM is manipulated using JavaScript.
     *
     * @param {*} el An element
     */
    function enableAccordions(el) {
        const accordion_buttons = el.querySelectorAll('.js-accordion-button');

        accordion_buttons.forEach((button) => {
            button.addEventListener('click', function () {
                toggleAccordion(this);
            });
        });
    }

    // Return an object to expose inner functions
    return {
        enableAccordions: enableAccordions,
    };
}

// Store tools in window
window.accordion_tools = accordion_tools();
